import React from 'react';
import { Scatter } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { registerables, Chart } from 'chart.js';
Chart.register(...registerables);

const UsersPerActivityChart = ({ data }) => {
  const intl = useIntl();
    
  const chartData = {
    datasets: [
      {
        label: intl.formatMessage({ id: 'moderatorUserTracking.perActivity.label.title', defaultMessage: 'Users attendance'}),
        data: data.map((item) => ({ x: item.name, y: item.trainingCount })), 
        backgroundColor: 'rgba(54, 162, 235, 0.6)', 
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    scales: {
      x: {
        type: 'category', 
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Scatter data={chartData} options={chartOptions} />; 
};
  
  
UsersPerActivityChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      trainingCount: PropTypes.number,
    })
  ),
};
  
export {UsersPerActivityChart};